<script lang="ts">
	interface Props {
		className?: string;
		strokeWidth?: number;
	}

	let { className = '', strokeWidth = 2 }: Props = $props();
</script>

<div class={className}>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 64 64"
		enable-background="new 0 0 64 64"
		xml:space="preserve"
		fill="none"
		stroke="currentColor"
		stroke-width={strokeWidth}
	>
		<rect x="1" y="1" stroke-miterlimit="10" width="27" height="27"></rect>
		<rect x="36" y="1" stroke-miterlimit="10" width="27" height="27"></rect>
		<rect x="1" y="36" stroke-miterlimit="10" width="27" height="27"></rect>
		<rect x="36" y="36" stroke-miterlimit="10" width="27" height="27"></rect>
	</svg>
</div>
